/** Raw Seed Release — the form: undecoded lots out to a party for trial use. */
import { createFileRoute } from "@tanstack/react-router";
import { ReleaseNewPage } from "@/features/warehouse/components/release-new-page";
import { asStage, useDeskFacility } from "@/features/warehouse/route-helpers";
import { guardDesk } from "../../-guard";

export const Route = createFileRoute("/_app/warehouse/$stage/release/new")({
  beforeLoad: ({ params }) => guardDesk(params.stage, "warehouse.release"),
  component: Page,
});

function Page() {
  const { stage } = Route.useParams();
  return (
    <ReleaseNewPage stage={asStage(stage)} facilityId={useDeskFacility()} />
  );
}
